import app from "/src/app/app.module";
import Customer from "../models/customer";

app.controller('search-customer-form', function ($scope, $search, $customer, vxUtils, msgBus) {

    var step = vxUtils.findObjectOnParents($scope, "selectedstep");


    $scope.found = [];

    // Initialize current customer model
    function initEmptyCustomer() {
        $scope.wizard.customer = new Customer();
        $scope.cust = $scope.wizard.customer;
    }

    if ($scope.wizard.customer === undefined) {
        // If a customer id was prefilled (from quote request), load that customer
        if ($scope.wizard.prefillCustomerId) {
            $customer.getCustomer(function (result) {
                $scope.wizard.customer = result;
                $scope.cust = result;
                
                // Mark step valid so wizard can continue
                msgBus.emitMsg('valForm', {
                    isValid: true,
                    scope: $scope
                });
            }, $scope.wizard.prefillCustomerId);
        } else {
            initEmptyCustomer();
        }
    } else {
        $scope.cust = $scope.wizard.customer;
    }

    $scope.selectCustomer = function (item) {
        if ($scope.wizard.selectedCustomer != null) {
            $scope.wizard.selectedCustomer.$selected = false;
        }
        $scope.wizard.selectedCustomer = item;
        $customer.getCustomer(function (result) {
            $scope.wizard.customer = result;
            $scope.cust = result;
            msgBus.emitMsg('valForm', {
                isValid: true,
                scope: $scope
            });
        }, item.ID);
        $scope.wizard.selectedCustomer.$selected = true;
    };

    $scope.$watch('wizard.searchCustomer', function (tmpStr) {

        if (!tmpStr || tmpStr.length == 0)
            return 0;
        // if searchStr is still the same..
        // go ahead and retrieve the data
        if (tmpStr === $scope.wizard.searchCustomer) {
            $search.search(function (results) {
                $scope.wizard.found = results;
            }, $scope.wizard.searchCustomer, '["customer"]');
        }
        return 0;
    });



});